import React from 'react';
import styled from 'styled-components';

const CenteredImage = styled.img`
position: absolute;
left: 50%;
top: 50%;
transform: translate(-50%, -50%);
width: 150px;
`;

const Loader = () => (
  <CenteredImage src={`${process.env.PUBLIC_URL}/images/load-products.gif`} />
);

export default Loader;
